define([
	"dojo/has",
	"dojo/json",
	"dojo/topic",
	"csi/keycloak/KeycloakAdapter",
	"reconnecting-websocket"
], function (has, json, topic, KeycloakAdapter, ReconnectingWebSocket) {
	const MAX_RETRIES = 10;

	const bWebSocketsEnabled = has("csi-websockets-enable");
	const webSocketFactory = !bWebSocketsEnabled ? null : function reconnectingWebSocketFactory(endPoint) {
		const options = {
			maxRetries: MAX_RETRIES,
			startClosed: true,
			//debug: true
		};

		const webSocket = new ReconnectingWebSocket.default(endPoint, [], options);
		return webSocket;
	}

	// Publish /csi/websocketchannel/RETRY_COUNT_EXCEEDED topic if retryCount reaches MAX_RETRIES
	function checkRetryCount(retryCount) {
		if (retryCount >= MAX_RETRIES) {
			topic.publish("/csi/websocketchannel/RETRY_COUNT_EXCEEDED");
		}
	}

	// global WebSocket for the server communication
	var ws = null;

	// the channel with some convienent methods
	var channel = {

		/**
		 * Send message to the server
		 */
		send: function (message) {
			if (ws) {
				ws.send(message);
				return true;
			} else {
				console.warn("Cannot send a message via WebSocket channel. " + (webSocketFactory ? "Is it closed or is the server misconfigured?" : (bWebSocketsEnabled ? "It is not supported by this browser." : "WebSocket support is disabled in csiConfig.js")));
				return false;
			}
		},

		/**
		 * Take csi/comm/Request object and send it as a message
		 */
		sendAsRequest: function (/*Request*/request) {
			return this.sendVerbContent("REQUEST", request.content);
		},

		/**
		 * Send the message formatted as {v:<verb>, c:<content>} as expected on C8 server endpoint
		 */
		sendVerbContent: function (/*String*/verb, /*String*/content) {
			var messageObj = {
				v: verb,
				c: content
			};

			return this.send(json.stringify(messageObj));
		},

		/**
		 * Try to open WebSocket if supported, but do not connect it yet
		 */
		initialize: function () {
			if (!webSocketFactory)
				return;


			try {
				ws = webSocketFactory(() => {
						const protocol = window.location.protocol.replace("http", "ws");
						let endPoint = protocol + "//" + window.location.host + "/csi-requesthandler/ws/WSEndpoint";
						const token = KeycloakAdapter.getTokenSync();
						if (token){
							endPoint = endPoint + "?access_token=" + token;
						}
						return endPoint;
					});
				ws.addEventListener("open", function () {
					console.log("WebSocket channel is connected", "retryCount=", ws.retryCount);
				});
				ws.addEventListener("message", function (evt) {
					try {
						//console.log("WebSocket message received:", evt);
						var msg = json.parse(evt.data);
						//console.log("WebSocket message:", msg);

						// publish topic "/csi/servermessage/<verb>" with the content and user data as parameters
						topic.publish("/csi/servermessage/" + msg.v, msg.c, msg.u);
					} catch (ex) {
						console.error("Exception in handling WebSocket message:", ex);
					}
				});
				ws.addEventListener("close", function (evt) {
					const retryCount = ws.retryCount;
					console.log("WebSocket connection is closed. code=", evt.code, "reason=", evt.reason, "wasClean=", evt.wasClean, "retryCount=", retryCount);
					checkRetryCount(retryCount);
				});
				ws.addEventListener("error", function (error) {
					const retryCount = ws.retryCount;
					console.log("WebSocket error: ", error, "retryCount=", retryCount);
					checkRetryCount(retryCount);
				});
			} catch (ex) {
				console.error("WebSocket exception: ", ex);
				ws = null;
			}
		},

		/**
		 * Reestablish WebSocket connection
		 */
		reconnect: function () {
			if (!webSocketFactory)
				return;

			ws.reconnect();
		},

		/**
		 * Returns true if WebSocket was initialized without errors
		 */
		isEnabled: function () {
			return ws != null;
		}
	}

	return channel;
});
